import React from 'react'
import styles from "./style.module.scss"

type Props = {
   text: string,
   image: string,
   children?: any
}

const Msg: React.FC<Props> = ({ image, text, children }) => {
   return (
      <div className={` d-flex card ${styles.msg}`}>
         <img src={image} alt={text} />
         <h2>{text}</h2>
         {children}
      </div>
   )
}

export default Msg